/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import resolveStr from '@stdlib/ndarray-base-dtype-resolve-str';


// MAIN //

/**
* Resolves a list of data type strings.
*
* ## Notes
*
* -   If the function is unable to resolve a data type string for a provided data type, the corresponding element in the returned array will be `null`.
*
* @param {Array} dtypes - list of data types
* @returns {Array} results
*
* @example
* var out = dtypes2strings( [ 'float32', 'float64' ] );
* // returns [...]
*
* @example
* var out = dtypes2strings( [ 'foo', 'bar' ] );
* // returns [ null, null ]
*/
function dtypes2strings( dtypes ) {
	var out;
	var i;

	out = [];
	for ( i = 0; i < dtypes.length; i++ ) {
		out.push( resolveStr( dtypes[ i ] ) );
	}
	return out;
}


// EXPORTS //

export default dtypes2strings;
